


















import ButtonLinkAtom from "@/shared/components/atoms/card/ButtonLinkAtom.vue"
import { computed, ComputedRef, defineComponent, PropType } from "@vue/composition-api"
import { IActivity } from "@/apps/MyStudyChoiceActivitiesWidget/models/activities-viewmodel"
import { useGetters } from "vuex-composition-helpers"

export default defineComponent({
    name: "OnlineActionsMolecule",
    components: { ButtonLinkAtom },
    props: {
        activity: {
            type: Object as PropType<IActivity>,
            required: true,
            default: () => { }
        },
        interactive: {
            type: Boolean,
            required: false,
            default: true
        },
        sharedClasses: {
            type: String,
            required: true,
            default: ""
        },
        participationClasses: {
            type: String,
            required: false,
            default: ""
        },
        cancellationClasses: {
            type: String,
            required: false,
            default: ""
        }
    },
    setup() {
        const { getConfig } = useGetters(['getConfig'])

        const isNow: ComputedRef<boolean> = computed((props): boolean => {
            let today = new Date()

            return (today.getTime() >= new Date(props.activity.onlineEventStartDateTime).getTime())
        })

        const canCancel: ComputedRef<boolean> = computed((props): boolean => {
            let today = new Date()
            return new Date(props.activity.dateAfterUserCannotCancelAnymore).getTime() >= today.getTime()
        })

        return {
            isNow,
            getConfig,
            canCancel
        }
    }
})
